<template>
  <div class="image-card">
    <div class="image-container">
      <h3 v-html="title"></h3>
      <div class="image">

        <!-- TONES 3 SUMMARY -->
        <Tones3Summary
          v-if="contentId === 'tones-3-summary'"
          id="tones3summary"
        />

        <!-- TONES 3 STUDY DESIGN -->
        <Tones3StudyDesign
          v-else-if="contentId === 'tones-3-study-design'"
          id="tones3studydesign"
        />

        <!-- TONES 3 PATIENT DISPOSITION -->
        <Tones3ParticipantDisposition
          v-else-if="contentId === 'tones-3-participant-disposition'"
          id="tones3participantdisposition"
        />

        <!-- TONES 5 SUMMARY -->
        <Tones5Summary
          v-else-if="contentId === 'tones-5-summary'"
          id="tones5summary"
        />

        <!-- TONES 5 STUDY DESIGN -->
        <Tones5StudyDesign
          v-else-if="contentId === 'tones-5-study-design'"
          id="tones5studydesign"
        />

        <!-- TONES 5 PARTICIPANT DISPOSITION -->
        <Tones5ParticipantDisposition
          v-else-if="contentId === 'tones-5-participant-disposition'"
          id="tones5participantdisposition"
        />

        <!-- ITC STUDY DESIGN -->
        <ITCStudyDesign
          v-else-if="contentId === 'itc-study-design'"
          id="itcstudydesign"
        />

        <!-- ITC ESS -->
        <ITCESS
          v-else-if="contentId === 'itc-ess'"
          id="itcess"
        />

        <!-- ITC MWT -->
        <ITCMWT
          v-else-if="contentId === 'itc-mwt'"
          id="itcmwt"
        />

        <!-- ITC CGI-C -->
        <ITCCGIC
          v-else-if="contentId === 'itc-cgi-c'"
          id="itccgic"
        />

        <!-- DRIVING STUDY DESIGN -->
        <DrivingStudyDesign
          v-else-if="contentId === 'driving-study-design'"
          id="drivingstudydesign"
        />

        <!-- DRIVING SDLP ASSESSMENT SCALE -->
        <DrivingSDLPAssessmentScale
          v-else-if="contentId === 'driving-sdlp-assessment-scale'"
          id="drivingsdlpassessmentscale"
        />

        <!-- DRIVING PERCENT IMPROVEMENT -->
        <DrivingPercentImprovement
          v-else-if="contentId === 'driving-percent-improvement'"
          id="drivingpercentimprovement"
        />

        <component
          v-else-if="resource"
          :is="resource"
        />
      </div>

      <div class="footnotes-container">
        <Footnotes
          v-if="footnotes.length > 0"
          :footnotes="footnotes"
          :vis-id="contentId"
          :vis-index="contentIndex"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Footnotes from '../../../../jazz-components/src/components/UIComponents/Footnotes.vue';

export default {
  name: 'ImageViewer',
  components: {
    Footnotes,
    Tones3Summary: () =>
      import('@/assets/cardImgs/tones-3-summary.svg?inline'),
    Tones3StudyDesign: () =>
      import('@/assets/cardImgs/tones-3-study-design.svg?inline'),
    Tones3ParticipantDisposition: () =>
      import('@/assets/cardImgs/tones-3-participant-disposition.svg?inline'),
    Tones5Summary: () => import('@/assets/cardImgs/tones-5-summary.svg?inline'),
    Tones5StudyDesign: () =>
      import('@/assets/cardImgs/tones-5-study-design.svg?inline'),
    Tones5ParticipantDisposition: () =>
      import('@/assets/cardImgs/tones-5-patient-disposition.svg?inline'),
    ITCStudyDesign: () =>
      import('@/assets/cardImgs/itc-study-design.svg?inline'),
    ITCESS: () => import('@/assets/cardImgs/itc-ess.svg?inline'),
    ITCMWT: () => import('@/assets/cardImgs/itc-mwt.svg?inline'),
    ITCCGIC: () => import('@/assets/cardImgs/itc-cgi-c.svg?inline'),
    DrivingStudyDesign: () =>
      import('@/assets/cardImgs/driving-study-design.svg?inline'),
    DrivingSDLPAssessmentScale: () =>
      import('@/assets/cardImgs/driving-sdlp-assessment-scale.svg?inline'),
    DrivingPercentImprovement: () =>
      import('@/assets/cardImgs/driving-percent-improvement.svg?inline'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    contentId: {
      type: String,
      default: '',
    },
    contentIndex: {
      type: Number,
      required: true,
    },
    footnotes: {
      type: Array,
      default: () => [],
    },
    resource: {
      type: Function,
    },
  },
  computed: {
    ...mapGetters([
      'activeRoute',
    ]),
  }
};
</script>

<style lang="scss" scoped>
.image-card {
  display: flex;
  height: 100%;
}

h3 {
  font-weight: normal;
  font-size: rem(20);
  text-align: left;
  margin: 0 35px 0 0;
  padding: 5px 5px 5px 0;
  color: #727272;

  @include iPadProStyles {
    font-size: rem(26);
  }
}

.image-container {
  position: relative;
  font-size: 11pt;
  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  svg {
    width: 100%;
    font-family: $font-roboto;
  }

  img {
    width: 100%;
  }

  .footnotes-container {
    text-align: left;
  }
}
</style>
